/// <reference types="google-publisher-tag" />

import { AdPlacement } from '@/features/ads/shared/types/ad-placement';
let gptServicesInitialized = false;

export const initGPTPlacements = (
  googletag: typeof window.googletag,
  placements: AdPlacement[],
) => {
  googletag.cmd.push(() => {
    if (!gptServicesInitialized) {
      googletag.pubads().disableInitialLoad();
      googletag.pubads().enableSingleRequest();
      googletag.enableServices();
      gptServicesInitialized = true;
    }

    placements.forEach((placement) => {
      const slot = googletag
        .defineSlot(
          placement.adUnitPath,
          [placement.size.width, placement.size.height],
          placement.code,
        )
        ?.addService(googletag.pubads());
      if (!slot) {
        console.warn('slot for placement', placement.code, 'was not initialized');
        return;
      }
      // This is used to determine if the slot refreshes after on impression viewed handler
      slot.setTargeting('shouldRefresh', placement.shouldRefresh ? 'true' : 'false');

      //@todo ensure hat product info etc is set as targeting key
      Object.entries(placement.targeting || {}).forEach(([key, value]) => {
        slot.setTargeting(key, value);
      });
    });
  });
};

export const impressionViewableHandler = (
  googletag: typeof window.googletag,
  handler: (event: googletag.events.ImpressionViewableEvent) => void,
) => {
  googletag.cmd.push(() => {
    googletag.pubads().addEventListener('impressionViewable', handler);
  });

  return () => {
    googletag.cmd.push(() => {
      googletag.pubads().removeEventListener('impressionViewable', handler);
    });
  };
};

export const refreshAdUnits = (googletag: typeof window.googletag, slot?: googletag.Slot[]) => {
  googletag.cmd.push(() => {
    googletag.pubads().refresh(slot);
  });
};

export const cleanupSlots = (googletag: typeof window.googletag) => {
  googletag.cmd.push(() => {
    const all = googletag.pubads().getSlots();
    if (all.length) googletag.destroySlots(all);
  });
};
